/**
 * Paths of the cowcamo-rails (Devise) pages that the experience links out to while
 * account flows are still aggregated on the cowcamo site instead of being handled
 * in-experience. The origin is derived at runtime from the per-environment
 * `termsOfUseUrl` (fallback: `privacyPolicyUrl`) configured on the sign-in
 * experience — except on the shared QA/STG tenant, where it comes from the QA
 * constants below.
 */
export const EXTERNAL_PASSWORD_RESET_PATH = '/user/password/new';
export const EXTERNAL_CONFIRMATION_RESEND_PATH = '/user/confirmation/new';
export const EXTERNAL_SIGN_UP_PATH = '/user/sign_up_with_sns';

/**
 * QA 用 RP の `app_id` と、その RP からの interaction で表示する cowcamo-rails の URL。
 *
 * QA と STG は 1 つの Logto テナントを共用しており (STG が主、QA が従)、Sign-in Experience が
 * 持つ terms/privacy URL は 1 組だけなので、必ず STG のものになる。QA 用 RP から来た
 * interaction は `app_id` で識別して、代わりにここの URL を読ませる。この URL から派生する
 * もの (`@/utils/site-origin` が導出する origin) もあわせて QA を向く。
 *
 * `QA_APP_ID` には QA 用 RP 自身の application ID を入れること。両環境をこの値だけで
 * 見分けているため、STG のものを入れると STG まで QA に切り替わってしまう。
 */
export const QA_APP_ID = 'rwdkouq9138pqdoe25k9u';
export const QA_TERMS_OF_USE_URL = 'https://qa.cowcamo.jp/terms';
export const QA_PRIVACY_POLICY_URL = 'https://qa.cowcamo.jp/policy';
